import React, { useEffect, useState } from "react";
import SideBar from "./SideBar";
import { use } from "react";
import axiosClient from "../axios";
import { Autocomplete, FormControl, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Edit } from "@mui/icons-material";

const Video = () => {
  const [allProvider, setAllProvider] = useState([]);
  const [partnerId, setPartnerId] = useState("");

  const [videoLink, setVideoLink] = useState("");
  const [hitNumber, setHitNumber] = useState(0);
  const [dailyLimit, setDailyLimit] = useState(0);
  const [timeGap, setTimeGap] = useState(10);
  const [countryCode, setCountryCode] = useState("IN");

  const [skipStatus, setSkipStatus] = useState({
    isSkip: false,
    timeGap: 0,
  });

  const [allCountry, setAllCountry] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");

  const [isActive, setIsActive] = useState(false);

  const navigate = useNavigate();

  const [triggerValue, setTriggerValue] = useState(1);

  const handleVideoSubmit = (e) => {
    if (triggerValue != "1" && !hitNumber) {
      alert("Please Enter Hit Number");
      return;
    }

    if (!videoLink || !dailyLimit || !timeGap) {
      alert("Please Fill All The Fields");
      return;
    }
    if (hitNumber < 0 || dailyLimit < 0 || timeGap < 0) {
      alert("Please Enter Positive Value");
      return;
    }

    let data = {
      triggerpoints: triggerValue,
      videoLink: videoLink,
      hitNumber: hitNumber,
      dailyLimit: dailyLimit,
      timeGap: timeGap,
      skipStatus: skipStatus,
      isActive: isActive,
      partnerId: partnerId,
      countryCode
    };

    axiosClient
      .post(`/newVideo`, data)
      .then((res) => {
        setVideoLink("");
        setHitNumber(0);
        setDailyLimit(0);
        setTimeGap(10);
        setSkipStatus(false);
        setIsActive(false);
        alert(res.data.message);
        navigate("/allVideo");
      })
      .catch((error) => {
        alert(error?.message);
        console.log(error);
      });
  };

  const getPartner = () => {
    axiosClient
      .get("/partnersList")
      .then((res) => setAllProvider(res.data.response))
      .catch((error) => console.log(error));
  };

  const handleTrigger = (e) => {
    setTriggerValue(e.target.value);
  };

  const getAllCountry = () => {
    axiosClient
      .get("/getAllCountry")
      .then((res) => {
        console.log("res of all country", res);
        setAllCountry(res?.data?.response);
      })
      .catch((error) => {
        console.log("Error In Getting All Country...");
      });
  };

  const [countryConfig, setCountryConfig] = useState({
    country_code: "",
    video_link: "",
  });

  useEffect(() => {
    getAllCountry();
  }, []);
  useEffect(() => {
    getPartner();
  }, []);

  return (
    <>
      <SideBar handleSideBar={true} activeTab={"allVideo"} />
      <div className="screen">
        <div className="video-heading">
          <p>Add Video</p>
        </div>

        <div className="video-container">
          <div className="video-item">
            <p style={{ width: "27%" }}>Select Trigger Points</p>
            <div className="video-item">
              {/* <p style={{ width: "27%" }}>Select Trigger Points</p> */}

              <select
                className="edit-select"
                value={triggerValue}
                onChange={handleTrigger}
              >
                <option value="" disabled selected>
                  -- Please choose an option --
                </option>

                <option value="1">is profiler</option>
                <option value="2">surveydisqualification</option>
                <option value="3">surveycomplete</option>
                <option value="4">task-games complete</option>
                <option value="5">task-games failed</option>
                <option value="6">is partner</option>
                <option value="7">profiler complete</option>
                <option value="8">125 earning not complete 1hour</option>
                <option value="9">125 not complete 1 day</option>
              </select>
            </div>
          </div>

          <div className="video-item">
            <p>Select Provider</p>
            <Autocomplete
              sx={{ width: "50%" }}
              disablePortal
              disabled={triggerValue != "6"}
              // value={?.name || "Select Partner"}
              onChange={(event, newValue) => {
                if (newValue) {
                  setPartnerId(newValue._id);
                } else {
                  setPartnerId("");
                }
              }}
              options={allProvider}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField {...params} label="Provider" />
              )}
            />
          </div>

          <div className="video-item">
            <p>Enter Video Link</p>
            <input
              type="text"
              value={videoLink}
              onChange={(e) => setVideoLink(e.target.value)}
              className="video-item-input"
              placeholder="Enter Video Link"
            />
          </div>
          <div className="video-item">
            <p>Enter Hit Number</p>
            <input
              type="Number"
              value={hitNumber}
              onChange={(e) => setHitNumber(Number(e.target.value))}
              className="video-item-input"
              onWheel={(e) => e.target.blur()}
            />
          </div>
          <div className="video-item">
            <p>Enter Daily Limit</p>
            <input
              type="Number"
              value={dailyLimit}
              onChange={(e) => setDailyLimit(Number(e.target.value))}
              className="video-item-input"
              onWheel={(e) => e.target.blur()}
            />
          </div>

          <div className="video-item">
            <p>Select Time Gap</p>
            <input
              type="Number"
              value={timeGap}
              onChange={(e) => setTimeGap(Number(e.target.value))}
              className="video-item-input"
              onWheel={(e) => e.target.blur()}
            />
          </div>

          <div className="video-item item-regionalConfigs">
            <p>Country</p>
            
            <FormControl sx={{ mb: 0, width: "300px" }}>
              <FormControl sx={{ mb: 0, width: "300px" }}>
                <Autocomplete
                  options={allCountry}
                  value={
                    allCountry.find(
                      (item) => item.alpha2 === countryCode
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setCountryCode(newValue?.alpha2 || "");
                  }}
                  getOptionLabel={(option) => option?.name || ""}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Country" />
                  )}
                />
              </FormControl>

            </FormControl>
            
          </div>

      
          <div className="video-item">
            <p>Skip Status</p>
            <div className="video-time-boolean skip-section">
              <div className="skipStatus">
                <label
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    fontFamily: "sans-serif",
                  }}
                >
                  Is Skip:
                </label>
                <div className="skipRadio">
                  <label htmlFor="">True</label>
                  <input
                    type="radio"
                    checked={skipStatus?.isSkip == true ? true : false}
                    onChange={() =>
                      setSkipStatus({ ...skipStatus, isSkip: Boolean(true) })
                    }
                  />
                </div>
                <div className="skipRadio">
                  <label htmlFor="">False</label>
                  <input
                    type="radio"
                    checked={skipStatus?.isSkip == false ? true : false}
                    onChange={() =>
                      setSkipStatus({ ...skipStatus, isSkip: Boolean(false) })
                    }
                  />
                </div>
              </div>

              <div className="skipStatus">
                <label
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    fontFamily: "sans-serif",
                  }}
                >
                  Time Gap:{" "}
                </label>
                <input
                  type="number"
                  disabled={skipStatus?.isSkip == false ? true : false}
                  style={{ padding: "5px 10px", borderRadius: "5px" }}
                  placeholder="Enter Time Gap."
                  value={skipStatus?.timeGap}
                  onChange={(e) =>
                    setSkipStatus({
                      ...skipStatus,
                      timeGap: Number(e.target.value),
                    })
                  }
                />
              </div>
            </div>
          </div>

          <div className="video-item">
            <p>Is Active </p>
            <div className="video-time-boolean">
              <label htmlFor="">True</label>
              <input
                type="radio"
                checked={isActive == true ? true : false}
                onChange={() => setIsActive(Boolean(true))}
              />
              <label htmlFor="">False</label>
              <input
                type="radio"
                checked={isActive == false ? true : false}
                onChange={() => setIsActive(Boolean(false))}
              />
            </div>
          </div>

          <div className="videoitem-submit" onClick={handleVideoSubmit}>
            Submit
          </div>
        </div>
      </div>
    </>
  );
};

export default Video;
